/* ==========================================================================
   Design System
   Variables
   ========================================================================== */
/* ==========================================================================
   Design System
   Breakpoint variables.

   NOTE: If any of the values in this file are adjusted,
         they need to be adjusted in vars-breakpoints.js as well.
   ========================================================================== */
/* ==========================================================================
   Design System
   Grid mixins
   ========================================================================== */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* ==========================================================================
   Design System
   Media queries
   ========================================================================== */
/* ==========================================================================
   Design System
   Base styles
   ========================================================================== */
.o-card-group > h2 {
  margin-bottom: 1.875rem;
}
.o-card-group--column-2 .o-card-group__cards {
  grid-template-columns: 1fr 1fr;
}
.o-card-group--column-3 .o-card-group__cards {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
@media only all and (max-width: 63.8125em) {
  .o-card-group--column-3 .o-card-group__cards {
    grid-template-columns: 1fr 1fr;
  }
}
.o-card-group__cards {
  display: grid;
  grid-column-gap: 1.25em;
  grid-row-gap: 1.25em;
}
@media only all and (max-width: 37.5em) {
  .o-card-group__cards {
    grid-template-columns: 100% !important;
  }
}
.o-card-group--bg-green {
  padding: 1.875em;
  background: var(--green-20);
}

/* stylelint-disable selector-type-no-unknown */
_:-ms-lang(x),
.o-card-group__cards {
  display: block;
}
_:-ms-lang(x) .m-card,
.o-card-group__cards .m-card {
  display: block;
  float: left;
  margin-bottom: 10px;
}

_:-ms-lang(x) .o-card-group__cards .m-card,
.o-card-group--column-2 .o-card-group__cards .m-card {
  width: 48%;
  margin-right: 2%;
}
_:-ms-lang(x) .o-card-group__cards .m-card:last-child,
.o-card-group--column-2 .o-card-group__cards .m-card:last-child {
  margin-right: 0;
}

_:-ms-lang(x) .o-card-group__cards .m-card,
.o-card-group--column-3 .o-card-group__cards .m-card {
  width: 32%;
  margin-right: 1%;
}
_:-ms-lang(x) .o-card-group__cards .m-card:last-child,
.o-card-group--column-3 .o-card-group__cards .m-card:last-child {
  margin-right: 0;
}

_:-ms-lang(x),
.o-card-group::after {
  content: "";
  display: table;
  clear: both;
}

/* stylelint-enable selector-type-no-unknown */
/* stylelint-disable no-duplicate-selectors */
.o-card-group {
  /* stylelint-enable no-duplicate-selectors */
}
.o-card-group--count-2 .m-card:nth-of-type(1), .o-card-group--count-3 .m-card:nth-of-type(1), .o-card-group--count-4 .m-card:nth-of-type(1) {
  grid-area: card1;
}
.o-card-group--count-2 .m-card:nth-of-type(2), .o-card-group--count-3 .m-card:nth-of-type(2), .o-card-group--count-4 .m-card:nth-of-type(2) {
  grid-area: card2;
}
.o-card-group--count-2 .m-card:nth-of-type(3), .o-card-group--count-3 .m-card:nth-of-type(3), .o-card-group--count-4 .m-card:nth-of-type(3) {
  grid-area: card3;
}
.o-card-group--count-2 .m-card:nth-of-type(4), .o-card-group--count-3 .m-card:nth-of-type(4), .o-card-group--count-4 .m-card:nth-of-type(4) {
  grid-area: card4;
}
.o-card-group--count-2 .o-card-group__cards {
  grid-template-columns: 1fr 1fr;
  grid-template-areas: "card1 card2";
}
.o-card-group--count-3 .o-card-group__cards {
  grid-template-columns: 1fr 1fr;
  grid-template-areas: "card1 card2" "card1 card3";
}
.o-card-group--count-3 .o-card-group__cards .m-card:nth-of-type(1) h3 {
  font-size: 1.625em;
  font-weight: 600;
  letter-spacing: inherit;
  line-height: 1.25;
  text-transform: inherit;
  margin-bottom: 0.5769230769em;
}
p + .o-card-group--count-3 .o-card-group__cards .m-card:nth-of-type(1) h3, ul + .o-card-group--count-3 .o-card-group__cards .m-card:nth-of-type(1) h3, ol + .o-card-group--count-3 .o-card-group__cards .m-card:nth-of-type(1) h3, dl + .o-card-group--count-3 .o-card-group__cards .m-card:nth-of-type(1) h3, figure + .o-card-group--count-3 .o-card-group__cards .m-card:nth-of-type(1) h3, img + .o-card-group--count-3 .o-card-group__cards .m-card:nth-of-type(1) h3, table + .o-card-group--count-3 .o-card-group__cards .m-card:nth-of-type(1) h3, blockquote + .o-card-group--count-3 .o-card-group__cards .m-card:nth-of-type(1) h3 {
  margin-top: 1.7307692308em;
}
h1 + .o-card-group--count-3 .o-card-group__cards .m-card:nth-of-type(1) h3, .h1 + .o-card-group--count-3 .o-card-group__cards .m-card:nth-of-type(1) h3, h3 + .o-card-group--count-3 .o-card-group__cards .m-card:nth-of-type(1) h3, .h3 + .o-card-group--count-3 .o-card-group__cards .m-card:nth-of-type(1) h3, h4 + .o-card-group--count-3 .o-card-group__cards .m-card:nth-of-type(1) h3, .h4 + .o-card-group--count-3 .o-card-group__cards .m-card:nth-of-type(1) h3, h5 + .o-card-group--count-3 .o-card-group__cards .m-card:nth-of-type(1) h3, .h5 + .o-card-group--count-3 .o-card-group__cards .m-card:nth-of-type(1) h3, h6 + .o-card-group--count-3 .o-card-group__cards .m-card:nth-of-type(1) h3, .h6 + .o-card-group--count-3 .o-card-group__cards .m-card:nth-of-type(1) h3 {
  margin-top: 1.1538461538em;
}
@media only all and (max-width: 37.5em) {
  p + .o-card-group--count-3 .o-card-group__cards .m-card:nth-of-type(1) h3, ul + .o-card-group--count-3 .o-card-group__cards .m-card:nth-of-type(1) h3, ol + .o-card-group--count-3 .o-card-group__cards .m-card:nth-of-type(1) h3, dl + .o-card-group--count-3 .o-card-group__cards .m-card:nth-of-type(1) h3, figure + .o-card-group--count-3 .o-card-group__cards .m-card:nth-of-type(1) h3, img + .o-card-group--count-3 .o-card-group__cards .m-card:nth-of-type(1) h3, table + .o-card-group--count-3 .o-card-group__cards .m-card:nth-of-type(1) h3, blockquote + .o-card-group--count-3 .o-card-group__cards .m-card:nth-of-type(1) h3 {
    margin-top: 1.3636363636em;
  }
}
@media only all and (max-width: 37.5em) {
  .o-card-group--count-3 .o-card-group__cards .m-card:nth-of-type(1) h3 {
    font-size: 1.375em;
    font-weight: 600;
    letter-spacing: inherit;
    line-height: 1.25;
    text-transform: inherit;
    margin-bottom: 0.6818181818em;
  }
  p + .o-card-group--count-3 .o-card-group__cards .m-card:nth-of-type(1) h3, ul + .o-card-group--count-3 .o-card-group__cards .m-card:nth-of-type(1) h3, ol + .o-card-group--count-3 .o-card-group__cards .m-card:nth-of-type(1) h3, dl + .o-card-group--count-3 .o-card-group__cards .m-card:nth-of-type(1) h3, figure + .o-card-group--count-3 .o-card-group__cards .m-card:nth-of-type(1) h3, img + .o-card-group--count-3 .o-card-group__cards .m-card:nth-of-type(1) h3, table + .o-card-group--count-3 .o-card-group__cards .m-card:nth-of-type(1) h3, blockquote + .o-card-group--count-3 .o-card-group__cards .m-card:nth-of-type(1) h3, h1 + .o-card-group--count-3 .o-card-group__cards .m-card:nth-of-type(1) h3, .h1 + .o-card-group--count-3 .o-card-group__cards .m-card:nth-of-type(1) h3, h2 + .o-card-group--count-3 .o-card-group__cards .m-card:nth-of-type(1) h3, .h2 + .o-card-group--count-3 .o-card-group__cards .m-card:nth-of-type(1) h3, h4 + .o-card-group--count-3 .o-card-group__cards .m-card:nth-of-type(1) h3, .h4 + .o-card-group--count-3 .o-card-group__cards .m-card:nth-of-type(1) h3, h5 + .o-card-group--count-3 .o-card-group__cards .m-card:nth-of-type(1) h3, .h5 + .o-card-group--count-3 .o-card-group__cards .m-card:nth-of-type(1) h3, h6 + .o-card-group--count-3 .o-card-group__cards .m-card:nth-of-type(1) h3, .h6 + .o-card-group--count-3 .o-card-group__cards .m-card:nth-of-type(1) h3 {
    margin-top: 1.3636363636em;
  }
}
.o-card-group--count-3 .o-card-group__cards .m-card:nth-of-type(1) > a {
  justify-content: center;
}
.o-card-group--count-4 .o-card-group__cards {
  grid-template-columns: 1fr 1fr;
  grid-template-areas: "card1 card2" "card3 card4";
}
.o-card-group--flow .o-card-group__cards {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

@media only all and (min-width: 37.5625em) and (max-width: 56.25em) {
  .o-card-group--count-3 .o-card-group__cards {
    grid-template-columns: 1fr 1fr;
    grid-template-areas: "card1 card1" "card2 card3";
  }
}
@media only all and (max-width: 37.5em) {
  .o-card-group--count-2 .o-card-group__cards {
    grid-template-columns: 1fr;
    grid-template-areas: "card1" "card2";
  }
  .o-card-group--count-3 .o-card-group__cards {
    grid-template-columns: 1fr;
    grid-template-areas: "card1" "card2" "card3";
  }
  .o-card-group--count-4 .o-card-group__cards {
    grid-template-columns: 1fr;
    grid-template-areas: "card1" "card2" "card3" "card4";
  }
  .o-card-group--flow .o-card-group__cards {
    display: block;
  }
  .o-card-group--flow .o-card-group__cards .m-card {
    width: 100%;
    margin-bottom: 1.875em;
  }
}